<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="packageName"
                placeholder="packageName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="lessonQty"
                placeholder="lessonQty"
                type="number"
                isIntegerOnly
                :fieldValue.sync="formData.lesson_count"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="price"
                placeholder="price"
                type="number"
                :fieldValue.sync="formData.price"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                isMultiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'PackageDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    formData: {
      name: '',
      lesson_count: '',
      price: '',
      schools: [],
    },
    tutorSchoolOptions: [],
  }),
  methods: {
    async getPackageById() {
      try {
        const data = await this.$Fetcher.GetPackageById(this.id)
        // staff只可以view所屬分校package
        if (this.$validate.DataValid(data.schools, true)) {
          let pass = false
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < data.schools.length; i++) {
            if (getUserSchools.includes(data.schools[i])) {
              pass = true
              break
            }
          }
          if (!pass) {
            this.permissionValid = false
            throw 'message.notBelongPackageBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        let isAllSchool = true
        for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
          if (this.tutorSchoolOptions[i].value !== -1) {
            const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
            if (!found) {
              isAllSchool = false
              break
            }
          }
        }
        if (isAllSchool) {
          this.formData.schools.push(-1)
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'PackageList',
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          name: this.formData.name,
          lesson_count: parseInt(this.formData.lesson_count),
          price: parseFloat(this.formData.price),
          schools: this.formData.schools.filter(el => el !== -1),
        }

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdatePackage(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewPackage(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'PackageList',
          }
        }

        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeletePackage(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'PackageList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 分校 Options =======
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return { value: el.id, text: el.name }
          })

          let disabledAll = false
          const getUserSchools = this.gfGetUserSchools()
          if (this.$validate.DataValid(this.id)) {
            // when edit，不屬於staff的分校會disabled
            this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
              const disabled = !getUserSchools.includes(el.value)
              if (disabled) {
                disabledAll = true
              }
              return {
                ...el,
                disabled: disabled,
              }
            })
          } else {
            // When create，只會攞staff所屬嘅分校
            this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
          }

          this.tutorSchoolOptions.unshift({
            value: -1,
            text: this.$t('allCenters'),
            disabled: disabledAll,
          })
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: PackageDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      await this._getTutorSchoolOptions()
      if (this.$validate.DataValid(this.id)) {
        // edit
        await this.getPackageById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
